import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const ContractPdfViewerModal = ({
  show,
  onHide,
  title = 'Contrato de préstamo',
  url,
  size = 'xl'
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (show && url) {
      setIsLoading(true);
      const timer = window.setTimeout(() => setIsLoading(false), 500);
      return () => window.clearTimeout(timer);
    }

    setIsLoading(false);
    return undefined;
  }, [show, url]);

  const handleClose = () => {
    setIsLoading(false);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size}
      className="pdf-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3">Cargando el documento...</p>
          </div>
        ) : (
          <div className="pdf-embed-container">
            <iframe
              src={url}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{ border: 'none' }}
              title={title}
              allow="fullscreen"
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light-secondary" onClick={handleClose}>
          <i className="fas fa-times me-2" aria-hidden="true"></i>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContractPdfViewerModal;
